import React, { Component } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import cm from 'helpers/commons';

class VBarChart extends Component {
  monetaryUnit = (num) => {
    return cm.monetaryUnit(num);
  };

  commons = (value, name, props) => {
    return cm.numberComma(value) + cm.unit();
  };

  render() {
    const { width, height, data } = this.props;

    let barchart = '';
    if (data && data.length > 0) {
      barchart = (
        <BarChart width={width} height={height} data={data} margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
          <XAxis dataKey="name" />
          <YAxis tickFormatter={this.monetaryUnit} />

          <CartesianGrid vertical={false} stroke="#ebf3f0" />
          <Tooltip formatter={this.commons} />
          {/* <Legend /> */}

          <Bar dataKey="식대금액" fill="#0bb656" minPointSize={5} />
        </BarChart>
      );
    } else {
      barchart = (
        <div className="box-mid">
          <div className="mid">
            <h3>데이터 내역이 없습니다.</h3>
          </div>
        </div>
      );
    }

    return <div style={{ width: width, height: height }}>{barchart}</div>;
  }
}

export default VBarChart;
